<template>
    <v-card>
        <v-card-text>
            <div class="pt-5" v-for="(content,idx) in content_controller.list" :key="idx">
                <component :content="content" :click="click" :is="getContentType(content)" />
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import contentVideo from "../video.vue";
    import contentImage from "../image.vue";
    import contentText from "../content-text.vue";

    export default {
        components: {
            contentVideo,
            contentText,
            contentImage
        },
        data() {
            return {
                content_controller: this.get_controller("content_section"),
                contentTypes: [{
                        text: "contentText",
                        value: 1
                    },
                    {
                        text: "contentImage",
                        value: 2
                    },
                    {
                        text: "contentVideo",
                        value: 3
                    },
                ],

            }
        },
        methods: {
            click(){},
            getContentType(content) {
                console.log(content);
                let contentType = this.contentTypes.find(
                    (x) => x.value == content.type
                );
                return contentType.text;
            },
        }
    };
</script>